import { apiFetch } from './api';
import {
  availableSlotsSchema,
  calendlyBookedResponseSchema,
  onboardingStatusSchema,
  type AvailableSlot,
  type CalendlyBookedResponse,
  type CalendlyBookingInput,
  type OnboardingFormInput,
  type OnboardingStatus,
} from '@/features/onboarding/schemas';

export async function getOnboardingStatus(): Promise<OnboardingStatus> {
  const data = await apiFetch<unknown>('/onboarding/status');
  return onboardingStatusSchema.parse(data);
}

export async function submitOnboardingForm(
  payload: OnboardingFormInput,
): Promise<OnboardingStatus> {
  const data = await apiFetch<unknown>('/onboarding/form', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return onboardingStatusSchema.parse(data);
}

export async function getAvailableSlots(startTime?: string): Promise<AvailableSlot[]> {
  const path = startTime
    ? `/onboarding/available-slots?startTime=${encodeURIComponent(startTime)}`
    : '/onboarding/available-slots';
  const data = await apiFetch<unknown>(path);
  return availableSlotsSchema.parse(data).slots;
}

export async function recordCalendlyBooking(
  input: CalendlyBookingInput,
): Promise<CalendlyBookedResponse> {
  const data = await apiFetch<unknown>('/onboarding/calendly-booked', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return calendlyBookedResponseSchema.parse(data);
}
